"use client";

import { useState, useEffect } from "react";
import { ShieldCheck, ChevronRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "@/components/ui/drawer";

export default function CaliiGuaranteeBanner() {
  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    setIsDesktop(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  const guaranteeContent = (
    <div className="space-y-4 text-muted-foreground">
      <p>
        En Calii nos comprometemos a entregarte productos frescos y de la mejor calidad.
        Si algo no cumple con tus expectativas, estamos aquí para ayudarte.
      </p>
      <ul className="list-disc list-inside space-y-2">
        <li>Reemplazo inmediato de productos dañados o en mal estado</li>
        <li>Reembolso completo si no estás satisfecho</li>
        <li>Atención al cliente disponible para resolver cualquier problema</li>
      </ul>
      <p className="text-sm">
        Simplemente contáctanos dentro de las 24 horas posteriores a tu entrega y
        resolveremos tu caso de inmediato.
      </p>
    </div>
  );

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-3 p-3 mb-6 w-full text-left rounded-lg border border-teal-200 bg-teal-50 hover:bg-teal-100/60 transition cursor-pointer"
      >
        <ShieldCheck className="h-8 w-8 text-teal-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-semibold text-sm text-teal-900">Garantía de calidad y frescura</p>
          <p className="text-xs text-teal-700">Reembolso o reemplazo si algo no te llega como te gusta.</p>
        </div>
        <ChevronRight className="h-5 w-5 text-teal-500 flex-shrink-0" />
      </button>

      {/* Desktop */}
      {isDesktop && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <div className="flex items-center gap-3 mb-2">
                <ShieldCheck className="h-8 w-8 text-teal-600" />
                <DialogTitle className="text-xl">Garantía Calii</DialogTitle>
              </div>
              <DialogDescription className="text-base">
                Garantía de calidad y frescura
              </DialogDescription>
            </DialogHeader>
            {guaranteeContent}
          </DialogContent>
        </Dialog>
      )}

      {/* Mobile */}
      {!isDesktop && (
        <Drawer open={open} onOpenChange={setOpen}>
          <DrawerContent>
            <DrawerHeader>
              <div className="flex items-center justify-center gap-3 mb-2">
                <ShieldCheck className="h-8 w-8 text-teal-600" />
                <DrawerTitle className="text-xl">Garantía Calii</DrawerTitle>
              </div>
              <DrawerDescription className="text-base">
                Garantía de calidad y frescura
              </DrawerDescription>
            </DrawerHeader>
            <div className="px-4 pb-8">
              {guaranteeContent}
            </div>
          </DrawerContent>
        </Drawer>
      )}
    </>
  );
}
